const KeyLabelCircledIcon = props => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#F4EFED" />
    <circle cx="25" cy="14" r="2" stroke="#0D0D0D" strokeWidth="1.5" />
    <circle cx="25" cy="14" r="6" stroke="#0D0D0D" strokeWidth="1.5" />
    <path
      d="M19.3877 16.8936L7.79726 28.484L10.516 31.2027L22.1064 19.6123"
      stroke="#0D0D0D"
      strokeWidth="1.5"
    />
    <rect
      x="16.5625"
      y="25.25"
      width="3.24827"
      height="5.65685"
      transform="rotate(45 16.5625 25.25)"
      stroke="#0D0D0D"
      strokeWidth="1.5"
    />
  </svg>
);

export default KeyLabelCircledIcon;
